import { FormikProvider, useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import * as graphql from '@treams/treams-network';
import { Button, FlexGap, Input, tokens } from '@treams/treams-ui';

export default function UserUpdateMissionForm(props: { user: graphql.User; returnURL?: string }) {
	const { t } = useTranslation();
	const history = useHistory();
	const [updateMission, { loading }] = graphql.useUserUpdateMissionMutation();

	const formik = useFormik({
		initialValues: {
			mission: props.user.mission,
		},
		onSubmit: async (values) => {
			await updateMission({
				variables: {
					input: {
						id: props.user.id,
						mission: values.mission,
					},
				},
			});

			if (props.returnURL) {
				history.push(props.returnURL);
			}
		},
	});

	return (
		<FormikProvider value={formik}>
			<FlexGap flexDirection="column" gap={tokens.gap.group}>
				<Input.Formik name="mission" label={t('users.updateMission.modal.label')} />
				<Button
					title={t('users.updateMission.modal.save')}
					loading={loading}
					onClick={() => formik.submitForm()}
					alignSelf="flex-start"
				/>
			</FlexGap>
		</FormikProvider>
	);
}
